import { SiteCreateAttributes } from "../../../../api/Api";

// Values are tied to the API `platform_cms` enum so any schema drift surfaces
// as a compile error here.
export const PLATFORMS: {
  label: string;
  value: SiteCreateAttributes["platform_cms"];
}[] = [
  { label: "WordPress", value: "wordpress" },
  { label: "Shopify", value: "shopify" },
  { label: "Wix", value: "wix" },
  { label: "Squarespace", value: "squarespace" },
  { label: "Webflow", value: "webflow" },
  { label: "HubSpot CMS", value: "hubspot" },
  { label: "Adobe Experience Manager", value: "adobe_experience_manager" },
  { label: "Lovable", value: "lovable" },
  { label: "Other", value: "other" },
];

export const TYPE_OF_BUSINESS = [
  { label: "E-commerce", value: "E-commerce" },
  { label: "AI / SaaS / Startup", value: "AI / SaaS / Startup" },
  { label: "Agency", value: "Agency" },
  { label: "Local Business", value: "Local Business" },
  { label: "Marketplace", value: "Marketplace" },
  { label: "Consulting", value: "Consulting" },
  { label: "Media", value: "Media" },
  { label: "Blog or Personal", value: "Blog or Personal" },
  { label: "Education", value: "Education" },
  { label: "Community", value: "Community" },
  { label: "Non-profit", value: "Non-profit" },
  { label: "Other", value: "Other" },
];
